// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2394(props) {
    return (
        <svg
            id="_x32_394"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        stroke: #b7b7b7;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st4 {\n        font-size: 5px;\n      }\n\n      .st4, .st5 {\n        font-family: ArialMT, Arial;\n        isolation: isolate;\n      }\n\n      .st6 {\n        fill: #5b5b5b;\n      }\n\n      .st1 {\n        stroke-miterlimit: 3.9;\n      }\n\n      .st1, .st2 {\n        stroke: #b3b3b3;\n      }\n\n      .st7, .st3 {\n        stroke-width: .8px;\n      }\n\n      .st7, .st3, .st8, .st9 {\n        stroke: #fff;\n      }\n\n      .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10, .st5 {\n        fill: #68836a;\n      }\n\n      .st11 {\n        fill: #ffec5f;\n      }\n\n      .st12 {\n        fill: #a88b49;\n      }\n\n      .st2 {\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .st13 {\n        fill: #7f7f7f;\n      }\n\n      .st5 {\n        font-size: 11px;\n      }\n\n      .st8 {\n        stroke-miterlimit: 4;\n        stroke-width: .8px;\n      }\n\n      .st9 {\n        stroke-miterlimit: 4;\n        stroke-width: .7px;\n      }\n\n      .st14 {\n        display: none;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="DET">
                <g id="compass">
                    <path
                        className="st6"
                        d="M233.3,193.2l-5.2,7.5-6.6,4.6,4.3-6.8,7.5-5.3Z"
                    />
                    <path
                        className="st13"
                        d="M237.8,188.3c6.2,5.9,6.4,15.8.4,21.9-5.9,6.2-15.8,6.4-21.9.4-6.2-5.9-6.4-15.8-.4-21.9,5.9-6.1,15.7-6.3,21.9-.4ZM217.2,209.8c5.6,5.4,14.6,5.2,20.1-.4,5.4-5.6,5.2-14.6-.4-20.1-5.6-5.4-14.6-5.2-20.1.4-5.4,5.6-5.2,14.6.4,20.1Z"
                    />
                    <path
                        className="st6"
                        d="M224,199.6c0-1.6,1.3-3,2.9-3s3,1.3,3,2.9-1.3,3-2.9,3-2.9-1.3-3-2.9ZM221.5,207l-2.1,2.2-.3-.3.5-2.5-1.5,1.5-.4-.4,2.1-2.2.3.3-.5,2.5,1.5-1.5.4.4Z"
                    />
                    <path
                        className="st11"
                        d="M225.4,199.6c0-.9.7-1.7,1.6-1.7s1.7.7,1.7,1.6-.7,1.7-1.6,1.7c-1,0-1.7-.7-1.7-1.6Z"
                    />
                </g>
                <g id="distances">
                    <text
                        id="right"
                        className="st5"
                        transform="translate(223.5 115.3)"
                    >
                        <tspan x={0} y={0}>
                            328
                        </tspan>
                    </text>
                    <text
                        id="right-center"
                        className="st5"
                        transform="translate(186.2 62.5)"
                    >
                        <tspan x={0} y={0}>
                            365
                        </tspan>
                    </text>
                    <text
                        id="center"
                        className="st5"
                        transform="translate(114.7 27.2)"
                    >
                        <tspan x={0} y={0}>
                            412
                        </tspan>
                    </text>
                    <text
                        id="left"
                        className="st5"
                        transform="translate(5.6 114.6)"
                    >
                        <tspan x={0} y={0}>
                            341
                        </tspan>
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield"
                        className="st12"
                        d="M24.8,102.6l.6-3,2.7-.8,1.8-1.8,1.8-1.7,1.8-1.8,1.8-1.8,1.8-1.9,1.8-1.8,1.8-1.8,1.8-1.9,1.9-1.8,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,1.9-1.9,2-2,2-2,2-2,2-2,2-2,2.1-2.1,2.1-2.1,2.2-2.1,2.2-2.2,2.2-2.2,2.3-2.3,2.3-2.3,2.3-2.3,2.4-2.4,2.4-2.4,2.5-2.5,2.5-2.5,2.6-2.2,2.8-1.3,2.8-1.3,2.8-1.3h51.6l2.8,1.2,2.8,1.2,2.8,1.2,2.8,1.2,2.5,2.5,2.5,2.5,2.4,2.4,2.4,2.4,2.3,2.3,2.3,2.3,2.3,2.3,1.4,4.2,1,4.8,1.9,2.5,2,2,2,2,2,2,2,2,2,2,1.9,1.9,1.9,1.9,1.9,1.9,1.9,1.8,1.9,1.9,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,1.8,2,1.6,1.7,1.8,1.8,1.8,1.8,1.7,1.7,1.9.9,2.5v3.3c0,0,0,4.6,0,4.6l-20.8,21v13.8l-25.5,37.8s-15.3,18.6-30,33.6h0c-14.7,15.1-30.2,8.9-36.7,2.7s-32-32.5-32-32.5l-35.3-58.4.3-3.6-17.4-17.6-.4-4.5Z"
                    />
                    <path
                        id="grass"
                        className="st10"
                        d="M111.3,211.3c-5.8-5.5-26.9-27.9-30.9-32l-23.8-39.9-7.9-12.6-.3-6-15.5-15.5,61.4-61.8s2.1-1.7,4.2-2.9,4.4-2,4.4-2l47.7.6,7.4,3.2,14.1,13.6.9,1.1,1.6,8.3,20.8,20.5,16.4,16.6,2,2.1-.4,2.2.4,2.1-18.7,18.9.6,13.9-14.2,21.1-13.3,18.8c0,0-14.6,14.9-29,29.7-2.1,2.1-8.5,8.5-14.4,8.3-6.8-.4-12.8-7.5-13.4-8.1Z"
                    />
                    <path
                        id="infield_sand"
                        className="st12"
                        d="M163.9,166.7l-1-1c-5-16-20-27.7-37.7-27.7s-32.7,11.7-37.7,27.7l-1,1,32.7,32.7v3.2l6.1,6.2,6-6v-3.4l32.6-32.7ZM120.8,197.2l-17.6-17.6,2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c.8.5,1.8.8,2.7.8s2-.3,2.7-.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5-17.6,17.6h-8.8Z"
                    />
                </g>
                <g id="persistent">
                    <g id="mound">
                        <path
                            id="pitching-mound"
                            className="st12"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                        />
                        <path
                            id="pitching-rubber"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4v-1.6Z"
                        />
                    </g>
                    <g id="lines">
                        <path
                            id="left-foul-line"
                            className="st3"
                            d="M125.2,203.2L24.5,102.6"
                        />
                        <path
                            id="right-foul-line"
                            className="st3"
                            d="M125.2,203.2l96.5-96.6"
                        />
                    </g>
                    <g id="bases">
                        <rect
                            id="third-base"
                            className="st9"
                            x={99.2}
                            y={175.1}
                            width={3}
                            height={3}
                            transform="translate(-95.4 122.9) rotate(-45)"
                        />
                        <rect
                            id="first-base"
                            className="st9"
                            x={148.1}
                            y={175.2}
                            width={3}
                            height={3}
                            transform="translate(-81.1 157.5) rotate(-45)"
                        />
                        <rect
                            id="second-base"
                            className="st8"
                            x={123.7}
                            y={148.6}
                            width={3}
                            height={3}
                            transform="translate(-69.5 132.5) rotate(-45)"
                        />
                        <polygon
                            id="home"
                            className="st7"
                            points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                        />
                    </g>
                </g>
            </g>
            <g id="grid" className="st14">
                <g>
                    <g id="numbers">
                        <text
                            className="st4"
                            transform="translate(91 184.1) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                90
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(56.5 153.8) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                200
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(71 168.4) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                150
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(80.4 177.7) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                120
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(41.6 139) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                250
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(27.5 124) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                300
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(12.7 109.2) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                350
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(15 75.9) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                400
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(15 49.4) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                450
                            </tspan>
                        </text>
                        <text
                            className="st4"
                            transform="translate(15 24.6) rotate(-44.2)"
                        >
                            <tspan x={0} y={0}>
                                500
                            </tspan>
                        </text>
                    </g>
                    <g id="surface29">
                        <path className="st1" d="M125.5,203.8L-22.5,55.8" />
                        <path className="st1" d="M124.8,203.8L272.8,55.8" />
                        <path className="st0" d="M125.1,203.5L45.4,10.9" />
                        <path className="st0" d="M125.1,203.5V-4.9" />
                        <path className="st0" d="M125.1,203.5L204.9,10.9" />
                    </g>
                    <path
                        id="_x31_00-line"
                        className="st1"
                        d="M89.8,168.1c9-9.1,21.6-14.8,35.4-14.8s26.2,5.6,35.3,14.6"
                    />
                    <path
                        id="_x32_00-line"
                        className="st1"
                        d="M66.2,144.5c15.1-15.1,35.9-24.5,59-24.5s43.8,9.3,58.8,24.4"
                    />
                    <path
                        id="_x39_0-line"
                        className="st1"
                        d="M98.5,176.8c6.8-6.9,16.2-11.1,26.7-11.1s19.7,4.2,26.5,11"
                    />
                    <path
                        id="_x31_20-line"
                        className="st1"
                        d="M80.9,159.3c11.3-11.4,27-18.4,44.3-18.4s32.8,7,44.1,18.3"
                    />
                    <path
                        id="_x32_50-line"
                        className="st1"
                        d="M51.5,129.8c18.8-18.9,44.9-30.6,73.7-30.6s54.7,11.6,73.6,30.5"
                    />
                    <path
                        id="_x33_00-line"
                        className="st1"
                        d="M36.8,115.1c22.6-22.7,53.9-36.7,88.4-36.7s65.7,14,88.3,36.6"
                    />
                    <path
                        id="_x33_50-line"
                        className="st1"
                        d="M21.8,100.6c26.4-26.6,63-43.1,103.4-43.1s76.6,16.3,103,42.7"
                    />
                    <path
                        id="_x34_50-line"
                        className="st1"
                        d="M-7.4,70.9C26.5,36.9,73.4,15.9,125.2,15.9s98.6,21,132.5,54.9"
                    />
                    <path
                        id="_x34_00-line"
                        className="st1"
                        d="M7.3,85.6c30.1-30.2,71.8-48.9,117.9-48.9s87.6,18.6,117.7,48.8"
                    />
                    <path
                        id="_x35_00-line"
                        className="st1"
                        d="M-22.1,56.2C15.5,18.4,67.6-4.9,125.2-4.9s109.5,23.3,147.2,61"
                    />
                </g>
                <g>
                    <rect
                        className="st2"
                        x={125.2}
                        y={16}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={18}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={20.1}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={22.2}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={24.3}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={26.3}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={28.4}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={30.5}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={32.6}
                        width={4.9}
                        height={2.1}
                    />
                    <rect
                        className="st2"
                        x={125.2}
                        y={34.6}
                        width={4.9}
                        height={2.1}
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue2394
